import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

/**
 * Search field used in list tables (AdminFields modals, Acquirer, ISO, Merchant, etc.).
 */
const ListSearchField = ({
  value,
  onChange,
  onSearch,
  label = "Search",
  placeholder,
  size = "small",
  fullWidth = false,
  sx,
}) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onSearch?.();
    }
  };

  return (
    <TextField
      label={label}
      placeholder={placeholder}
      size={size}
      fullWidth={fullWidth}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      sx={sx}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={onSearch}
              edge="end"
              aria-label="search"
              size="small"
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ListSearchField;
